import { FolderApi, DocumentApi } from '../../test-api/index.ts'
import Toast from '@/frontapp/mixins/actions/Toast'
import useBcFolderStore from '@/frontapp/store/bcFolder'
import { $t } from 'nette-base-module/js/vuei18next'
import handleApiError from '../../utils/handleApiError'

const folderApi = new FolderApi({}, '/api/v2')
const documentApi = new DocumentApi({}, '/api/v2')

export default async function (documentsIds, foldersIds) {
  const bcFolderStore = useBcFolderStore()

  if (documentsIds.length) {
    await handleApiError(() => documentApi.documentMultipleRestoreDeleted({ ids: documentsIds }))
    documentsIds.forEach(bcFolderStore.deleteDocument)
  }

  if (foldersIds.length) {
    await handleApiError(() => folderApi.folderMultipleRestoreDeleted({ids: foldersIds}))
    foldersIds.forEach(bcFolderStore.deleteFolder)
  }

  bcFolderStore.setResetNeeded()

  const sum = documentsIds.length + foldersIds.length
  Toast(
    'success',
    sum === 1 ? $t('Item was restored') : $t('%cnt% items were restored', { cnt: sum })
  )
}